<template>
    <div id="fiche-bu-safety-leader-manager-block">
        <div class="flex text-center background-secondary">
            <div class="col-6">
                <as-title class="color-white" :title="$t('ficheBu.detail.safety_leader_manager_block.title')"
                    :size="4"></as-title>
            </div>
            <div class="col-6">
                <as-title class="color-white" :title="$t('ficheBu.detail.safety_leader_manager_block.title_2')"
                    :size="4"></as-title>
            </div>
        </div>
        <div class="flex background-secondary-light">
            <div class="col-6 flex align-items-center">
                <div class="safety-leader p-2">
                    <template v-if="selectedEntrepriseSafetyLeader">
                        <img :src="getSelectedEntrepriseSafetyLeaderImage()" />
                        <span class="ml-3">
                            {{ selectedEntrepriseSafetyLeader.prenom + " " + selectedEntrepriseSafetyLeader.nom }}
                        </span>
                    </template>
                    <template v-else>
                        <img :src="noUserImg" />
                        <span class="ml-3"> {{ $t("unknown") }}</span>
                    </template>
                </div>
            </div>
            <div class="col-6 flex align-items-center">
                <div class="safety-leader w-100">
                    <template v-if="edit && isAdmin">
                        <img class="mr-1" v-if="managerImgPreview" :src="managerImgPreview" />
                        <div class="flex">
                            <FileUpload class="button-default file-upload" mode="basic" :customUpload="true"
                                @select="onSelectedImage" accept="image/*"
                                :chooseLabel="$t('agenda_form.choose_img_button')" :multiple="false" />
                            <InputText class="w-100 mt-1" v-model="managerValue" />
                        </div>
                    </template>
                    <template v-else>
                        <img :src="managerImg || noUserImg" />
                        <span class="ml-3"> {{ managerValue || $t("unknown") }}</span>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import InputText from 'primevue/inputtext';
import FileUpload from "primevue/fileupload";

import { bufferToJpegBase64 } from '../../util';
import AsTitle from '../Elements/AsTitle.vue';
import roleMixins from "@/mixins/roleMixins";

export default {
    name: "FicheBuSafetyLeaderManagerBlock",
    components: {
        AsTitle,
        FileUpload,
        InputText
    },
    props: {
        edit: Boolean,
        ficheBu: Object,
        managerImg: Object,
        selectedEntrepriseSafetyLeader: Object,
    },
    mixins: [roleMixins],
    watch: {
        edit() {
            this.managerImgPreview = null
        },
    },
    computed: {
        managerValue: {
            get() {
                return this.ficheBu?.manager || "";
            },
            set(val) {
                if (this.ficheBu) {
                    this.ficheBu.manager = val;
                }
            }
        }
    },
    methods: {
        getSelectedEntrepriseSafetyLeaderImage() {
            if (
                this.selectedEntrepriseSafetyLeader &&
                this.selectedEntrepriseSafetyLeader.photo &&
                this.selectedEntrepriseSafetyLeader.photo.data.length > 0
            ) {
                return bufferToJpegBase64(this.selectedEntrepriseSafetyLeader.photo.data);
            } else {
                return this.noUserImg;
            }
        },
        onSelectedImage(event) {
            this.ficheBu.managerImgToUpload = event.files[0];
            this.managerImgPreview = event.files[0].objectURL;
        },
    },
    data() {
        return {
            noUserImg: new URL("../../assets/images/no-user-image.jpg", import.meta.url).href,
            managerImgToUpload: undefined,
            managerImgPreview: undefined,
        };
    },
};
</script>

<style lang="scss">
#fiche-bu-safety-leader-manager-block {
    .safety-leader {
        display: flex;
        align-items: center;

        >span {
            border-radius: 15px;
        }

        img {
            width: 75px;
            height: 75px;
            border-radius: 50%;
        }
    }
}
</style>
